export default __webpack_public_path__ + "static/media/tag.0782d644.svg";